import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "./store";
import { icons } from "@/components/Base/Lucide";

export interface Menu {
  icon: keyof typeof icons;
  title: string;
  badge?: number;
  pathname?: string;
  subMenu?: Menu[];
  ignore?: boolean;
}

export interface SideMenuState {
  menu: Array<Menu | string>;
  selectedUserId?: string;
}

const initialState: SideMenuState = {
  menu: [
    "DATA",
    {
      icon: "LayoutDashboard",
      pathname: "/master-stock-data",
      title: "Master Stock Data",
    },
    {
      icon: "TableProperties",
      pathname: "/team-data",
      title: "Team Data",
    },
    "INVENTORY",
    {
      icon: "PackagePlus",
      pathname: "/stock-in",
      title: "Stock IN",
    },
    {
      icon: "PackageMinus",
      pathname: "/stock-out",
      title: "Stock Out",
    },
    {
      icon: "ArrowLeftRight",
      pathname: "/stock-movements",
      title: "Stock Movements",
    },
    {
      icon: "RefreshCcw",
      pathname: "/trade-in",
      title: "Trade In",
    },
    {
      icon: "Receipt",
      pathname: "/reimbursements",
      title: "Reimbursements",
    },
    {
      icon: "BadgePercent",
      pathname: "/rebates",
      title: "Rebates",
    },
    {
      icon: "BookOpenText",
      pathname: "/rebate-ledger",
      title: "Rebate Ledger",
    },
    "MANAGE",
    {
      icon: "Users",
      pathname: "/users",
      title: "User",
    },
    {
      icon: "UsersRound",
      pathname: "/teams",
      title: "Team",
    },
    {
      icon: "Package",
      pathname: "/products",
      title: "Product",
    },
    {
      icon: "Truck",
      pathname: "/distributors",
      title: "Distributor",
    },
  ],
  selectedUserId: undefined,
};

export const sideMenuSlice = createSlice({
  name: "sideMenu",
  initialState,
  reducers: {
    setCompanyId: (state, action) => {
      const companyId = action.payload;

      // Update the pathname for company-specific items
      state.menu = state.menu.map((item) => {
        if (typeof item !== "string") {
          // Reserved for future multi-company scoping (if needed).
          // For now, keep menu paths static for StockLedger.
        }
        return item;
      });
    },
    setUserId: (state, action) => {
      state.selectedUserId = action.payload;
    }
  },
});

export const { setCompanyId, setUserId } = sideMenuSlice.actions;

export const selectSideMenu = (state: RootState) => state.sideMenu.menu;

export default sideMenuSlice.reducer;

